<section class="ops-consent" data-testid="ai-consent-ops-record">
  <app-ai-consent-fact [state]="current()" />

  @if (latest(); as row) {
    <dl class="ops-consent__facts">
      <dt>Given by</dt>
      <dd>
        {{ row.consented_by }}, for the business
        @if (row.given_as === 'AGENT') {
          (introducing agent)
        }
      </dd>
      @if (row.state === 'WITHDRAWN') {
        <dt>Withdrawn</dt>
        <dd data-testid="ops-consent-route">
          {{ row.withdrawal_route ? routeLabels[row.withdrawal_route] : '' }}
        </dd>
        @if (row.withdrawal_route === 'OPS_EMAIL') {
          <dt>Email arrived</dt>
          <dd data-testid="ops-consent-arrived">{{ row.revoked_at | date: 'medium' }}</dd>
          <dt>Recorded</dt>
          <dd>{{ row.withdrawal_recorded_at | date: 'medium' }} by {{ row.revoked_by }}</dd>
          <dt>Sender</dt>
          <dd>
            {{ row.withdrawal_sender || 'Not stated' }} —
            {{ standingLabel(row.withdrawal_sender_standing) }}
            @if (row.withdrawal_standing_basis) {
              ({{ row.withdrawal_standing_basis }})
            }
          </dd>
        } @else {
          <dt>By</dt>
          <dd>{{ row.revoked_by }}, {{ row.revoked_at | date: 'medium' }}</dd>
        }
        @for (check of row.director_checks; track check.recorded_at) {
          <dt>Director check</dt>
          <dd>
            {{ check.result }} against {{ check.cipc_disclosure }} ({{
              check.cipc_disclosure_date | date: 'mediumDate'
            }}), recorded by
            {{ check.recorded_by }}
          </dd>
        }
      }
    </dl>
  }

  <div class="ops-consent__actions">
    @if (canRecordEmail()) {
      <button
        mat-stroked-button
        type="button"
        data-testid="ops-consent-email-open"
        (click)="openEmail()"
      >
        Record an emailed withdrawal
      </button>
    }
    @if (checkPending()) {
      <button
        mat-stroked-button
        type="button"
        data-testid="ops-consent-check-open"
        (click)="openCheck()"
      >
        Record the director check
      </button>
    }
  </div>
</section>
